import {Component, Input} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-moc-detail',
  templateUrl: './moc-detail.component.html'
})
export class MocDetailComponent extends BaseComponent {
  moc:any;

  @Input()
  netId:any;

  net:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    if (this.netId) {
      this.http.get(`${this.env.e.url}/domain/nets/${this.netId}`).subscribe(
        data => {
          this.net = data as any;
        }
      );
    }

    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/domain/mocs/${id}`).subscribe(
            data => {
              this.moc = data as any;
            }
          );
        }
      });
  }

  createNew() {
    this.moc = {
      value: '',
      netId: this.netId
    };
  }

  save() {
    if (!this.moc.id) {
      this.http.post(`${this.env.e.url}/domain/mocs`, this.moc)
        .subscribe(
          data => {
            this.moc = data;
            this.alertService.info(`Created ${this.moc.value}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/domain/mocs/${this.moc.id}`, this.moc)
        .subscribe(
          data => {
            this.moc = data;
            this.alertService.info(`Updated MOC Settings`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/domain/mocs/${this.moc.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted MOC ${this.moc.value}`);
          this.router.navigate(["/mocs"]);
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
